import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import {get, valuesIn, filter, pick, find, includes, intersectionWith, merge} from 'lodash';
import * as syncActions from '../../../redux/actionCreators/sync';
import * as companyApi from '../../../redux/actionCreators/async/companies';
import * as companyStore from '../../../redux/actionCreators/sync/companies';
import * as jobRequestApi from '../../../redux/actionCreators/async/jobrequests';
import * as jobRequestStore from '../../../redux/actionCreators/sync/jobrequests';
import * as adminStore from '../../../redux/actionCreators/sync/index';
import JobRequestTable from '../../../common/components/JobRequestTable';
import Button from '../../../common/components/Button';
import {COMPANY_STATUS} from '../../../common/enums';

@connect((state) => ({
  allowAddJobRequest: (state.contactProfile.company.companyStatus === COMPANY_STATUS.QUALIFIED_PROSPECT || state.contactProfile.company.companyStatus === COMPANY_STATUS.ACTIVE_ACCOUNT || state.contactProfile.company.companyStatus === COMPANY_STATUS.INACTIVE_ACCOUNT),
  jobs: valuesIn(state.jobRequests),
  contactProfile: state.contactProfile,
  contacts: valuesIn(state.companyContacts),
  staticData: state.staticData,
  filters: state.admin.jobRequests.filters,
  searchTerms: state.admin.jobRequests.searchTerms,
  bqpMigrationFeature: state.staticData.featureToggles.find(feature => feature.hardcodelink === 'BQP_MIGRATION_FEATURE').value === true,
}))

export default class JobRequestHistory extends Component {

  static propTypes = {
    contactProfile: PropTypes.object,
    jobs: PropTypes.array,
    contacts: PropTypes.array,
    dispatch : PropTypes.func.isRequired,
    searchTerms: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    filters: PropTypes.object,
    staticData: PropTypes.object,
    allowAddJobRequest: PropTypes.object,
    bqpMigrationFeature : PropTypes.bool,
  }

  constructor(props, context) {
    super(props, context);

    const roles = intersectionWith(this.props.staticData.contactTypes, get(this.props.contactProfile, 'profile.types', []), (type, id) => type.id == id);
    const isAdmin = intersectionWith(['HR', 'Owner', 'Billing', 'Executive', 'Main', 'Technology'], roles, (name, type) => type.name == name);
    this.state = {
      roles,
      contactAdmin: isAdmin.length
    };
  }

  componentDidMount() {
    this.props.dispatch(syncActions.setNavState({isOpen: false, hideClose: false}));
  }

  disableEditButton = (jobRequest) => {
    return jobRequest.primaryContactId !== this.props.contactProfile.profile.id;
  }

  onJobRequestTermsChange(terms = []) {
    this.props.dispatch(adminStore.updateJobRequestTerms(terms));
  }

  onJobRequestFilterChange(filters = {}) {
    this.props.dispatch(adminStore.updateJobRequestFilters(filters));
  }

  fetchJobRequests(filters = {}, terms = [], skip) {
    const callbacks = {
      success: (items) => this.props.dispatch(jobRequestStore.updateJobRequests(items)),
      error: (err) => console.error('getAllJobs failed', err),
    };

    this.props.dispatch(jobRequestApi.getAllJobs(
      callbacks,
      skip,
      terms,
      filters,
      this.props.contactProfile.company.id
    ));
  }

  render() {

  const {jobs} = this.props || {};
  const columns = ['IdNoLink', 'Date', 'Title', 'Openings', 'Status', 'Actions'];
  const isHR = Boolean(this.state.contactAdmin); // check if contact's type is one of the admin roles

  if (isHR) {
    columns.splice(4, 0, 'Contact');
  }

      return (
        <div className='job-request-history'>
          <JobRequestTable
            jobRequestsList={jobs}
            contacts={this.props.contacts}
            disableEditButton={this.disableEditButton}
            columns={columns}
            companyId={this.props.contactProfile.company.id}
            showContactFilter={this.state.contactAdmin ? true : false}
            linksInNewTab
            onJobRequestTermsChange={::this.onJobRequestTermsChange}
            onJobRequestFilterChange={::this.onJobRequestFilterChange}
            fetchJobs={::this.fetchJobRequests}
            searchTerms={this.props.searchTerms || []}
            filters={this.props.filters}
            showFilters={false}
          />
          {
            this.props.allowAddJobRequest &&
            !this.props.bqpMigrationFeature &&
            <div className='add-job-button' data-id='Add Job Request'>
              <Button
                data-id='add-button'
                className='button-main-large'
                onClick={() => this.props.dispatch(push('/client/jobrequest'))}
                label='Add Job Request'/>
            </div>
          }
        </div>
    );

  }
}

export function OnEnterLoadJobRequestHistory(store) {

  return (nextState, replace, done) => {
    const state = store.getState();
    const companyId = get(state, 'user.companyId');

    loadJobRequestHistory(companyId, store.dispatch)
      .then(() => {
        done();
      })
      .catch((err) => {
         return done(err || new Error('An error occurred in OnEnterLoadJobRequestHistory.'));
      });

    done();
  };
}


export function loadJobRequestHistory(companyId, dispatch) {

  const callbacks = {
    success: (items) => dispatch(jobRequestStore.updateJobRequests(items)),
    error: (err) => console.error('getAllJobs failed', err),
  };

  const companyJobsPromise = dispatch(jobRequestApi.getAllJobs(
    callbacks,
    0,
    [],
    {},
    companyId
  ));

  const companyContactsPromise = dispatch(companyApi.getCompanyContacts(companyId, (err, data) => {
    const companyContacts = get(data, 'body.data.items', []);
    dispatch(companyStore.updateCompanyContacts(companyContacts));
    return companyContacts;
  }));

  return Promise.all([companyJobsPromise, companyContactsPromise]);

}



// WEBPACK FOOTER //
// ./shared/react/client/JobRequestHistory/index.js